import { Document, Page } from 'react-pdf';

export const PdfViewerCanvas = ({
  containerRef,
  loading,
  error,
  pdfUrl,
  pageNumber,
  scale,
  onDocumentLoadSuccess,
  onDocumentLoadError,
  onRenderSuccess,
}) => (
  <div data-testid="pdf-viewer-container" ref={containerRef} className="flex flex-1 justify-center overflow-auto bg-zinc-800 py-8">
    {loading ? (
      <div data-testid="pdf-viewer-loading" className="flex h-64 items-center justify-center">
        <div className="text-zinc-400">Chargement du PDF...</div>
      </div>
    ) : null}

    {error ? (
      <div data-testid="pdf-viewer-error" className="flex h-64 items-center justify-center">
        <div className="text-red-400">{error}</div>
      </div>
    ) : null}

    <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess} onLoadError={onDocumentLoadError} loading="" className="shadow-2xl">
      <Page
        pageNumber={pageNumber}
        scale={scale}
        renderTextLayer
        renderAnnotationLayer
        className="bg-white"
        onRenderSuccess={onRenderSuccess}
      />
    </Document>
  </div>
);
